export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M16 26c5.525 0 10-4.475 10-10S21.525 6 16 6 6 10.475 6 16s4.475 10 10 10zm12-10c0 6.63-5.37 12-12 12S4 22.63 4 16 9.37 4 16 4s12 5.37 12 12z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "currentColor",
    "viewBox": "0 0 32 32"
  }
};